// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { xBaseTheme } from "@tps/XDL/types";

import accordion from "@tps/XDL/PreStyle/accordion";
import breadcrumbs from "@tps/XDL/PreStyle/breadcrumbs";
import breakpoints from "@tps/XDL/PreStyle/breakpoints";
import button from "@tps/XDL/PreStyle/button";
import checkbox from "@tps/XDL/PreStyle/checkbox";
import colors from "@tps/XDL/PreStyle/colors";
import dataTable from "@tps/XDL/PreStyle/dataTable";
import datePicker from "@tps/XDL/PreStyle/datePicker";
import drawer from "@tps/XDL/PreStyle/drawer";
import dynamicDropdown from "@tps/XDL/PreStyle/dynamicDropdown";
import focus from "@tps/XDL/PreStyle/focus";
import formField from "@tps/XDL/PreStyle/formField";
import globalStyle from "@tps/XDL/PreStyle/globalStyle";
import header from "@tps/XDL/PreStyle/header";
import icon from "@tps/XDL/PreStyle/icon";
import link from "@tps/XDL/PreStyle/link";
import lists from "@tps/XDL/PreStyle/lists";
import loadingOverlay from "@tps/XDL/PreStyle/loadingOverlay";
import loadingSpinner from "@tps/XDL/PreStyle/loadingSpinner";
import modal from "@tps/XDL/PreStyle/modal";
import overflowMenu from "@tps/XDL/PreStyle/overflowMenu";
import pagination from "@tps/XDL/PreStyle/pagination";
import panelMenu from "@tps/XDL/PreStyle/panelMenu";
import radio from "@tps/XDL/PreStyle/radio";
import select from "@tps/XDL/PreStyle/select";
import shadows from "@tps/XDL/PreStyle/shadows";
import tab from "@tps/XDL/PreStyle/tab";
import tag from "@tps/XDL/PreStyle/tag";
import textArea from "@tps/XDL/PreStyle/textArea";
import textField from "@tps/XDL/PreStyle/textField";
import toast from "@tps/XDL/PreStyle/toast";
import tooltip from "@tps/XDL/PreStyle/tooltip";
import typography from "@tps/XDL/PreStyle/typography";
import zIndex from "@tps/XDL/PreStyle/zIndex";

export default {
    breakpoints,
    colors,
    focus,
    shadows,
    // transition,
    globalStyle,
    typography,
    zIndex,
    accordion,
    breadcrumbs,
    button,
    checkbox,
    // clickable,
    dataTable,
    datePicker,
    drawer,
    dynamicDropdown,
    // fileUpload,
    header,
    formField,
    // fieldSet,
    icon,
    // layoutTable,
    // layoutGroup,
    // layoutCell,
    link,
    lists,
    // lazyImage,
    loadingOverlay,
    loadingSpinner,
    // menu,
    modal,
    overflowMenu,
    pagination,
    panelMenu,
    radio,
    select,
    // swatch,
    tab,
    tag,
    // tagsField,
    // textField,
    // tokenExFrame,
    textArea,
    toast,
    tooltip,
} as xBaseTheme;
